import { useState } from 'react'

import { useAuthActions } from '../hooks/useAuthActions'
import { useAuthDataHandler } from '../hooks/useAuthDataHandler'

const useLogin = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  const { handleStandardLogin, handleSilentEntityLogin } = useAuthActions()
  const { getLoginToken } = useAuthDataHandler()

  const resetError = () => setError(false)
  const resetLoading = () => setIsLoading(false)

  const login = async ({ username, password, needLoginToken }) => {
    setIsLoading(true)
    setError(false)

    try {
      const result = await handleStandardLogin({
        username,
        password,
        needLoginToken,
      })

      return result
    } catch (loginError) {
      setError(loginError)
      setIsLoading(false)
    }
  }

  const loginWithEntity = async (entityDetails) => {
    const loginToken = getLoginToken()
    if (loginToken) {
      return await handleSilentEntityLogin({ loginToken, ...entityDetails })
    } else {
      return null
    }
  }

  return {
    login,
    loginWithEntity,
    loading: isLoading,
    error,
    resetError,
    resetLoading,
    setLoading: setIsLoading,
  }
}

export default useLogin
